import { decryptAES128 } from "../../utils/utilitiesmodule";
import "../../utils/messages";
import { SERVICEACCOUNT_MESSAGES } from "../../utils/messages";
import { ClientMessage } from "../../utils/objects";

export function assignServiceAccountRequests(api) {
    /******************************************SERVICE ACCOUNTS******************************************************************/
    //export const serviceAccountAPI = {
    api.getServiceAccounts = async function () {
        var response = await api.get('/enterprise/svcaccounts', this.buildConfig())
            .then(res => res.data)
            .catch(e => {
                this.checkError(e, SERVICEACCOUNT_MESSAGES.LIST_NOT_RETRIEVED);
                return [];
            });

        return response;
    }
    api.createServiceAccount = async function (serviceAccount) {
        var clientMessage = ClientMessage.success(SERVICEACCOUNT_MESSAGES.CREATED, { 0: serviceAccount.name }, "serviceAccount");
        if (!serviceAccount.port)
            serviceAccount.port = 0;
        if (!serviceAccount.status)
            serviceAccount.status = 1;
        var response = await api.post('/enterprise/svcaccounts/', serviceAccount, this.buildConfig())
            .then(res => res.data)
            .catch(e => {
                clientMessage = this.checkError(e, SERVICEACCOUNT_MESSAGES.NOT_CREATED, { 0: serviceAccount.name });
                return null;
            });

        this.emitFunction("sendClientMessage", clientMessage, "serviceAccount");

        return response;
    }
    api.editServiceAccount = async function (serviceAccount) {
        var clientMessage = ClientMessage.success(SERVICEACCOUNT_MESSAGES.MODIFIED, { 0: serviceAccount.name }, "serviceAccount");

        if (serviceAccount.crypted) {
            //I seguenti campi arrivano cryptati, ma per utilizzarli, li decripto
            serviceAccount.password = [undefined, null, ""].includes(serviceAccount.password) ? serviceAccount.password : decryptAES128(serviceAccount.password);
            serviceAccount.client_secret = [undefined, null, ""].includes(serviceAccount.client_secret) ? serviceAccount.client_secret : decryptAES128(serviceAccount.client_secret);
            serviceAccount.token = [undefined, null, ""].includes(serviceAccount.token) ? serviceAccount.token : decryptAES128(serviceAccount.token);
            serviceAccount.refresh_token = [undefined, null, ""].includes(serviceAccount.refresh_token) ? serviceAccount.refresh_token : decryptAES128(serviceAccount.refresh_token);
            serviceAccount.crypted = false;
        }

        if (!serviceAccount.port) {
            serviceAccount.port = 0;
        }
        if (!serviceAccount.status) {
            serviceAccount.status = 1;
        }
        var response = await api.put('/enterprise/svcaccounts/', serviceAccount, this.buildConfig())
            .then(res => res.data)
            .catch(e => {
                clientMessage = this.checkError(e, SERVICEACCOUNT_MESSAGES.NOT_MODIFIED, { 0: serviceAccount.name });
                return null;
            });

        this.emitFunction("sendClientMessage", clientMessage, "serviceAccount");

        return response;
    }
    api.deleteServiceAccount = async function (saID, saName) {
        var clientMessage = ClientMessage.success(SERVICEACCOUNT_MESSAGES.DELETED, { 0: saName }, "serviceAccount");

        var response = await api.delete('/enterprise/svcaccounts/' + saID, this.buildConfig())
            .then(() => true)
            .catch(e => {
                if (e.status == 404)
                    return true;
                clientMessage = this.checkError(e, SERVICEACCOUNT_MESSAGES.NOT_DELETED, { 0: saName });
                return false;
            });

        this.emitFunction("sendClientMessage", clientMessage, "serviceAccount");

        return response;
    }
}
